let commonPlugin = {}
commonPlugin.install = function(Vue, options) {
	let reCharts = {
		resizeCharts() {
			let echarts = require('echarts/lib/echarts')
			let $echartsDoms = document.querySelectorAll('[_echarts_instance_]')
			let einstance = null

			for (let i = 0, len = $echartsDoms.length; i < len; i++) {
				einstance = echarts.getInstanceByDom($echartsDoms[i])
				if (einstance && einstance.resize) {
					einstance.resize()
				}
			}
		},
		windowResizeECharts() {
			let timer
			let _this = this
			window.onresize = function() {
				if (timer) {
					clearTimeout(timer)
					timer = null
				}

				timer = setTimeout(function() {
					_this.resizeCharts()
				}, 500)
			}
		}
	}

	Vue.prototype.$reCharts = reCharts

	// 验证
	Vue.prototype.$validatorInteger = function(rule, value, callback) {
		if (Number.isInteger(Number(value)) && Number(value) > 0) {
			callback()
		} else {
			callback(new Error('请输入正整数'))
		}
	}

	Vue.prototype.$bankCard = function(rule, value, callback) {
		if (/^[0-9]{16,21}$/.test(value)) {
			callback()
		} else {
			callback(new Error('不是有效的银行卡号'))
		}
	}

	// 清空对象
	Vue.prototype.$clearObj = function(obj) {
		for (let x in obj) {
			if (Object.prototype.toString.call(obj[x]) === '[object Array]') {
				obj[x] = []
			} else if (Object.prototype.toString.call(obj[x]) === '[object Object]') {
				obj[x] = {}
			} else {
				obj[x] = ''
			}
		}
		return obj
	}

	/**
	 * url：需要下载的对象 或者 下载文件的地址
	 * saveName：保存的文件名
	 * */
	Vue.prototype.$openDownloadDialog = function(url, saveName) {
		// for ie 10 and later
		if (window.navigator.msSaveBlob) {
			try {
				window.navigator.msSaveBlob(url, downloadFileName);
			} catch (e) {
				console.log(e);
			}
		}
		// 谷歌浏览器 创建a标签 添加download属性下载
		else {
			if (typeof url == 'object' && url instanceof Blob) {
				url = URL.createObjectURL(url); // 创建blob地址
			}
			var aLink = document.createElement('a');
			aLink.href = url;
			aLink.download = saveName || ''; // HTML5新增的属性，指定保存文件名，可以不要后缀，注意，file:///模式下不会生效
			var event;
			if (window.MouseEvent) {
				event = new MouseEvent('click');
			} else {
				event = document.createEvent('MouseEvents');
				event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
			}
			aLink.dispatchEvent(event);
		}
	}
}
export default commonPlugin



// WEBPACK FOOTER //
// ./src/plugins/common.js